<!--教师均衡发展驾驶舱-->
<template>
    <div class="cockpit-container">
        <div class="cockpit-container-scrollbar">
            <div class="cockpit-title-container">
                <div class="flex-item left-container"></div>
                <div class="flex-item center-container">教师均衡发展驾驶舱</div>
                <div class="flex-item right-container">
                    <el-form-item label="">
                        <el-select @change="statOrgChange"
                                   v-model="orgId"
                                   filterable
                                   style="width: 140px;margin-top: 5px;"
                                   placeholder="请选择">
                            <el-option v-for="item in orgList" :key="item.orgId" :label="item.orgName"
                                       :value="item.orgId" />
                        </el-select>
                    </el-form-item>

                </div>
            </div>

            <div class="content-container">
                <div class="l-content-container">
                    <!--教师数据-->
                    <div class="t-data-container">
                        <div class="data-title-container">
                            <div class="title-container1"></div>
                            <div class="title-container2">教师数据</div>
                            <div class="title-container3">{{timestampToTime(currentTime)}}更新</div>
                        </div>
                        <div class="td-container">
                            <div class="l-td-container">
                                <div class="l-child-container">
                                    <div class="l-title1">{{schoolCount}}</div>
                                    <div class="l-title2">学校</div>
                                </div>
                                <div class="l-child-container">
                                    <div class="l-title1">{{Math.floor(teacherCount*0.75)}}</div>
                                    <div class="l-title2">活跃用户</div>
                                </div>
                                <div class="l-child-container">
                                    <div class="l-title1">{{Math.floor(teacherCount*0.15)}}</div>
                                    <div class="l-title2">当前在线人数</div>
                                </div>
<!--                                <div class="l-child-container">-->
<!--                                    <div class="l-title1">18%</div>-->
<!--                                    <div class="l-title2">档案完善进度</div>-->
<!--                                </div>-->
                            </div>
                            <div class="r-td-container">
                                <div class="r-child-container">
                                    <div class="title1">{{teacherCount}}</div>
                                    <div class="title2">注册教师</div>
                                </div>
                                <div class="r-child-container">
                                    <div class="title1">
                                        <svg width="80" height="40" viewBox="0 0 80 40" preserveAspectRatio="none">
                                            <path d="M0,10 L25,35 L50,10 L75,35" fill="none" stroke="#ffffff"
                                                  stroke-width="1" style="vector-effect: non-scaling-stroke;" />
                                        </svg>
                                    </div>
                                    <div class="title-btn cursor" @click="viewTeaList">注册教师></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--学历年龄分析-->
                    <div class="age-xl-data-container">
                        <div class="xl-data-container">
                            <div class="data-title-container">
                                <div class="title-container1"></div>
                                <div class="title-container2">学历分析</div>
                            </div>
                            <div>
                                <xl-echarts :count-list1="teacherXl.countList1"
                                            :count-list2="teacherXl.countList2"/>
                            </div>
                        </div>
                        <div class="age-data-container">
                            <div class="data-title-container">
                                <div class="title-container1"></div>
                                <div class="title-container2">年龄分析</div>
                            </div>
                            <div>
                                <tea-age-echarts :age1-count="info.age1Count"
                                                 :age2-count="info.age2Count"
                                                 :age3-count="info.age3Count"
                                                 :age4-count="info.age4Count"
                                                 :age5-count="info.age5Count" />
                            </div>
                        </div>
                    </div>
                    <!--教龄分析-->
                    <div class="jl-data-container">
                        <div class="data-title-container">
                            <div class="title-container1"></div>
                            <div class="title-container2">教龄分布</div>
                        </div>
                        <div class="jl-container">
                            <div class="jl-item">
                                <jl1-echarts id="jl1Echarts01"
                                             :tea-count="this.teacherCount"
                                             :tea-time-count="info.teaTime1Count"
                                             :tea-time-rate="info.teaTime1Rate"/>
                            </div>
                            <div class="jl-item">
                                <jl2-echarts id="jl2Echarts01"
                                             :tea-count="this.teacherCount"
                                             :tea-time-count="info.teaTime2Count"
                                             :tea-time-rate="info.teaTime2Rate"/>
                            </div>
                            <div class="jl-item">
                                <jl3-echarts id="jl3Echarts01"
                                             :tea-count="this.teacherCount"
                                             :tea-time-count="info.teaTime3Count"
                                             :tea-time-rate="info.teaTime3Rate"/>
                            </div>
                            <div class="jl-item">
                                <jl4-echarts id="jl4Echarts01"
                                             :tea-count="this.teacherCount"
                                             :tea-time-count="info.teaTime4Count"
                                             :tea-time-rate="info.teaTime4Rate"/>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="r-content-container">
                    <!--职称分析-->
                    <div class="zc-data-container">
                        <div class="data-title-container">
                            <div class="title-container1"></div>
                            <div class="title-container2">职称分析</div>
                        </div>
                        <div>
                            <tea-zc-echarts :tea-count="this.teacherCount"
                                            :rank1-count="info.rank1Count"
                                            :rank2-count="info.rank2Count"
                                            :rank3-count="info.rank3Count"
                                            :rank4-count="info.rank4Count"
                                            :rank5-count="info.rank5Count"
                                            :rank6-count="info.rank6Count"/>
                        </div>
                    </div>
                    <!--任教学科分布-->
                    <div class="rj-data-container">
                        <div class="data-title-container">
                            <div class="title-container1"></div>
                            <div class="title-container2">任教学科分布</div>
                        </div>
                        <el-scrollbar class="rj-container">
                            <div class="rj-item" v-for="item in teaSubjectList">
                                <div class="rj-item-c1">
                                    <div class="child1">{{item.subjectName}}</div>
                                    <div class="child2">{{item.teacherCount}}人</div>
                                    <div class="child3">{{item.teacherRate}}%</div>
                                </div>
                                <div class="rj-item-c2">
                                    <el-progress
                                      :text-inside="true"
                                      :stroke-width="5"
                                      :percentage="item.teacherRate"
                                      color="#e54c5e"
                                      status="exception">
                                    </el-progress>
                                </div>
                            </div>
                        </el-scrollbar>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <el-dialog title="教师列表" v-model="isTeaListShow" width="600px">
        <el-table show-overflow-tooltip height="calc(100vh - 300px)"
                  border
                  :data="teacherList"
                  highlight-current-row>
            <el-table-column type="index" align="center" label="序号" width="60" />
            <el-table-column width="120" align="center" label="教师姓名" prop="trueName">
            </el-table-column>
            <el-table-column width="145" align="center" label="教师账号" prop="username">
            </el-table-column>
            <el-table-column width="80" align="center" label="学段" prop="periodName">
            </el-table-column>
            <el-table-column width="150" align="center" label="学科" prop="subjectName">
            </el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
import {timestampToTime} from "@/utils/date";
import xlEcharts from "@/components/cockpit/xlEcharts.vue";
import teaAgeEcharts from "@/components/cockpit/teaAgeEcharts.vue";
import teaAgePieEcharts from "@/components/echart/teaAgePieEcharts.vue";
import teaZcEcharts from "@/components/cockpit/teaZcEcharts.vue";
import jl1Echarts from "@/components/cockpit/jl1Echarts.vue";
import jl2Echarts from "@/components/cockpit/jl2Echarts.vue";
import jl3Echarts from "@/components/cockpit/jl3Echarts.vue";
import jl4Echarts from "@/components/cockpit/jl4Echarts.vue";
import { teacherStatistics,teacherStatisticsOrg } from "@/api/admin/cockpit"
import {ElLoading} from "element-plus";
export default {
    name: "teacherCockpit",
    components: {jl1Echarts,jl2Echarts,jl3Echarts,jl4Echarts, teaAgePieEcharts, xlEcharts,teaAgeEcharts,teaZcEcharts},
    data() {
        return {
            timestampToTime,
            currentTime:new Date().getTime(),
            isTeaListShow:false,
            orgId:"",
            info:{},
            orgList:[],
            schoolList:[],
            schoolCount:0,
            teacherList:[],
            teacherCount:0,
            teaSubjectList:[],
            teacherXl:{},// 学历
            orgInfo:{},
        };
    },
    created() {
        this.queryTeacherStatistics();
    },
    activated() {},
    watch: {},
    methods: {
        queryTeacherStatistics(){
            const loading = ElLoading.service({ fullscreen: true })
            teacherStatistics().then(res => {
                if (res.data.code === 1){
                    this.info = res.data.data;
                    this.orgList = this.info.orgList;
                    this.schoolList = this.info.schoolList;
                    this.schoolCount = this.info.schoolCount;
                    this.teacherList = this.info.teacherList;
                    this.teacherCount = this.info.teacherCount;
                    this.teaSubjectList = this.info.teacherSubjectList;
                    this.teacherXl = this.info.teacherXl;
                    loading.close()
                }else {
                    this.$message.error("请求出错")
                    loading.close()
                }
            })
        },
        viewTeaList(){
            this.isTeaListShow = true;
        },
        statOrgChange(){
            const loading = ElLoading.service({ fullscreen: true })
            teacherStatisticsOrg({orgId:this.orgId}).then(res => {
                if (res.data.code === 1){
                    this.info = res.data.data;
                    this.schoolList = this.info.schoolList;
                    this.schoolCount = this.info.schoolCount;
                    this.teacherList = this.info.teacherList;
                    this.teacherCount = this.info.teacherCount;
                    this.teaSubjectList = this.info.teacherSubjectList;
                    this.teacherXl = this.info.teacherXl;
                    loading.close()
                }else {
                    this.$message.error("请求出错")
                    loading.close()
                }
            })
        },
    }
};
</script>

<style scoped>
.cockpit-container{
    width: 100%;
    height: auto;
    background: #2076ff;
    font-family: 'SourceHanSansSC', sans-serif;
}
.cockpit-container-scrollbar{
    width: 100%;
    height: calc(100vh - 10px);
    overflow-x: hidden!important;
    box-sizing: border-box;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
}
.cockpit-container-scrollbar::-webkit-scrollbar {
    display: none;
}
/*标题*/
.cockpit-title-container{
    width: 100%;
    height: 50px;
    display: flex;
}
.left-container{
    width: 200px;
    height: 50px;
    color: #fff;
}
.right-container{
    width: 200px;
    height: 50px;
    color: #fff;
}
.center-container{
    width: calc(100% - 400px);
    height: 40px;
    color: #fff;
    line-height: 40px;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
}
.flex-item:last-child{
    margin-left: auto;
}
/*统计区域*/
.content-container{
    width: 100%;
    height: calc(100vh - 60px);
    padding: 0 20px 10px 20px;
    box-sizing: border-box;
    display: flex;
}
.l-content-container{
    width: 75%;
    height: 100%;
    padding: 0 20px 0 0;

}
.r-content-container{
    width: calc(25% - 20px);
    height: 100%;
}
/*统一标题模块*/
.data-title-container{
    width: 100%;
    height: 30px;
    display: flex;
    padding: 10px 0 0 20px;
    box-sizing: border-box;
}
.title-container1{
    width: 6px;
    height: 100%;
    background-color: #56e6f1;
}
.title-container2{
    width: auto;
    height: 20px;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    padding-left: 8px;
    line-height: 20px;
}
.title-container3{
    width: auto;
    height: 20px;
    color: #fff;
    font-size: 14px;
    padding-left: 20px;
    line-height: 24px;
}
/*教师数据模块*/
.t-data-container{
    width: 100%;
    height: 140px;
    background-color: #205ae0;
    border-radius: 15px;
}
.td-container{
    width: 100%;
    height: 100px;
    display: flex;
    padding: 0 10px 0 30px;
    box-sizing: border-box;
}
.l-td-container{
    width: calc(100% - 240px);
    height: 100px;
    display: flex;
    padding: 15px 10px 10px 10px;
    box-sizing: border-box;
}
.l-child-container{
    width: 25%;
    height: 100%;
    padding: 0 0 0 10px;
    box-sizing: border-box;
}
.r-td-container{
    width: 240px;
    height: 90px;
    background-color: #f7753b;
    border-radius: 15px;
    display: flex;
    padding: 10px;
    box-sizing: border-box;
}
.r-child-container{
    width: 50%;
    height: 100%;
}
.title1{
    color: #fff;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
}
.title2{
    color: #fff;
    text-align: center;
    font-size: 14px;
}
.l-title1{
    color: #fff;
    height: 40px;
    line-height: 40px;
    font-size: 24px;
    font-weight: bold;
}
.l-title2{
    color: #fff;
    font-size: 14px;
}
.title-btn{
    width: 90%;
    height: 20px;
    color: #fff;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    background-color: #fdb63a;
    border-radius: 10px;
    margin: auto;
    margin-top: 5px;
}
/*年龄学历分析*/
.age-xl-data-container{
    width: 100%;
    height: calc(50vh - 120px);
    padding: 20px 0 0 0;
    box-sizing: border-box;
    display: flex;
}
.xl-data-container{
    width: calc(100% - 340px);
    height: 100%;
    padding: 0 0 0 0;
    box-sizing: border-box;
    background-color: #205ae0;
    border-radius: 15px;
}
.age-data-container{
    width: 320px;
    height: 100%;
    margin-left: 20px;
    background-color: #205ae0;
    box-sizing: border-box;
    border-radius: 15px;
}
/*教龄分析*/
.jl-data-container{
    width: 100%;
    height: calc(50vh - 120px);
    background-color: #205ae0;
    box-sizing: border-box;
    border-radius: 15px;
    padding: 0 0 10px 0;
    margin-top: 20px;
}
.jl-container{
    width: 100%;
    height: calc(100% - 30px);
    padding: 10px 20px 10px 20px;
    display: flex;
    box-sizing: border-box;
}
.jl-item{
    width: 25%;
    height: 100%;
}
/*职称分析模块*/
.zc-data-container{
    width: 100%;
    height: calc(50vh + 20px);
    background-color: #205ae0;
    box-sizing: border-box;
    border-radius: 15px;
    padding: 0 0 10px 0;
}
/*任教学科分析模块*/
.rj-data-container{
    width: 100%;
    height: calc(50vh - 120px);
    background-color: #205ae0;
    box-sizing: border-box;
    border-radius: 15px;
    padding: 0 0 10px 0;
    margin-top: 20px;
}
.rj-container{
    width: 100%;
    height: calc(100% - 30px);
    padding: 10px 10px 10px 10px;
    box-sizing: border-box;
}
.rj-item{
    width: 100%;
    height: 36px;
}
.rj-item-c1{
    width: 100%;
    height: 26px;
    display: flex;
    color: #FFFFFF;
    font-size: 13px;
}
.child1{
    width: calc(100% - 100px);
    height: 100%;
}
.child2{
    width: 60px;
    height: 100%;
    text-align: right;
}
.child3{
    width: 40px;
    height: 100%;
    text-align: right;
}
.rj-item-c2{
    width: 100%;
    height: 10px;
}
</style>